module.exports = {
  submitShipping: function(xhr, event){
   $('body').trigger('gtm:eec:checkoutOption', xhr.responseJSON);
  },
  submitPayment: function(xhr, event) {
    $('body').trigger('gtm:eec:checkoutOption', xhr.responseJSON);
    $('body').trigger('gtm:ga4:checkoutOption', xhr.responseJSON);
  },
  placeOrder : function(xhr) {
    $('body').trigger('gtm:ga4:checkoutOption', xhr.responseJSON);
  }
}